/**
 *  PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *  Copyright © 2024 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */
/**
 * @file AgenticTextConstants.jsx - A component that handles text or canned message constants.
 */

// STORAGE_KEY
export const SIDEPANEL_EXPANDED = 'sidepanel_expanded';

// Agent Icon name
export const AGENT_ICON = 'AgentIcon';

// Conditional Edge Texts
export const CONDITIONAL_EDGE = 'Conditional Edge';
export const CONDITIONAL_EDGE_DESCRIPTION = 'Check this before creating an edge to make it conditional (dashed)';
export const CONDITIONAL_EDGE_TIP = 'Tip: Select nodes & press Delete or right-click.';

// Graph Icon Label
export const NEW_GRAPH = 'New Graph';
export const LOAD_GRAPH = 'Load Graph';
export const SAVE_GRAPH = 'Save Graph';
export const RESET_GRAPH = 'Reset Graph';
export const COPY_GRAPH = 'Copy Graph';
export const CONFIGURE_NODE = 'Configure Node';
export const PUBLISH_GRAPH = 'Publish Graph';

// Graph Node Labels
export const ADD_START_NODE = 'Add START Node';
export const ADD_SUPERVISOR_NODE = 'Add Supervisor Node';
export const ADD_AGENT_NODE = 'Add Agent Node';
export const ADD_TOOL_NODE = 'Add Tool Node';
export const ADD_END_NODE = 'Add END Node';
export const GROUP_UNGROUP = 'Toggle group';
export const LABEL_PARSERS = 'Parsers';

// Graph Node type
export const START = 'start';
export const SUPERVISOR = 'supervisor';
export const AGENT = 'agent';
export const TOOL = 'tool';
export const END = 'end';
export const GROUP = 'group';

// Graph Node action keys
export const CREATE = 'create';
export const RESET = 'reset';
export const COPY = 'copy';
export const LOAD = 'load';
export const SAVE = 'save';
export const PUBLISH = 'publish';

// Header constants texts
export const SELECT_TENANT = 'Select Tenant';
export const BERLIN_STUDIO = 'Berlin Studio';

// Node button constants
export const DETACH = 'Detach';
export const DETACH_FROM_GROUP = 'Detach from group';
export const UN_GROUP = 'Ungroup';
export const UN_GROUP_NODES = 'Ungroup nodes';

// Agentic Roles
export const GRAPH_ADMIN = 'graph_admin';
export const GRAPH_VIEW = 'graph_view';

// Tenant Contants
export const DEFAULT_TENANT_NAME = 'aistudytools';
export const ADDITIONAL_METADATA_PLACEHOLDER = `Enter JSON like: ${JSON.stringify(
  {
    layout: {
      type: 'pills',
      position: 'top',
      alignment: 'left',
      direction: 'horizontal'
    }
  },
  null,
  2
)}`;

export const ADDITIONAL_METADATA_LABEL = 'Additional Metadata (JSON)';

export const CONNECTION_RULES = [
  'start → supervisor/agent (workflow starts with supervisor or agent)',
  'supervisor → agent (supervisor can connect to agents)',
  'supervisor → end (supervisor can connect to end)',
  'agent → agent/tool/end (agents can call other agents, tools, or end)',
  'tool → agent (tools return output to agents)',
  'No connections to start',
  'No connections from end',
  'No self connections'
];

export const INSTRUCTIONS_ARIA_LABEL = 'instructions';

export const GRAPH_CONNECTION_RULES = 'Graph Connection Rules';

// STREAMING CHUNKS & GO DEEPER constants
export const DONE = 'done';
export const VIEW = 'view';
export const CHUNK = 'chunk';
export const JSON_TEXT = 'JSON';
export const META_DATA = 'metadata';
export const STREAMING = 'streaming';
export const GO_DEEPER_MESSAGE = 'Ready to go deeper?';
export const GO_DEEPER_SUB_MESSAGE = 'Explore one of these follow-ups to push your understanding even further.';
